import { render } from "./Ribbon.vue?vue&type=template&id=ece12cb8&scoped=true"
import script from "./Ribbon.vue?vue&type=script&lang=js"
export * from "./Ribbon.vue?vue&type=script&lang=js"

import "./Ribbon.vue?vue&type=style&index=0&id=ece12cb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece12cb8"]])

export default __exports__